import React from 'react'
import { StickyContainer } from 'react-sticky'
import { Helmet } from 'react-helmet'

import Menu from '../Menu'
import Header from '../Global/Header'
import Footer from '../Global/Footer'

import { GlobalStyle } from '../../styles/reset.css'

import { Container, Main } from './style'

import favicon from '../../assets/favicon.ico'

function Layout({ children, showMenu, routes }) {
  return (
    <StickyContainer>
      <Helmet
        title="SkyPostal Developers"
        meta={[
          { name: 'description', content: '...' },
          { name: 'keywords', content: '....' }
        ]}
        link={[{ rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }]}
      />
      <GlobalStyle />
      <Header />
      <Container>
        {showMenu && routes && <Menu routes={routes} />}
        <Main>{children}</Main>
      </Container>
      <div
        style={{
          display: 'flex',
          padding: '3rem 0',
          backgroundColor: '#f8f9fa'
        }}
      >
        <Footer />
      </div>
    </StickyContainer>
  )
}

export default Layout
